<template>
  <!-- 标题 高级筛选 -->
  <div class="bg-shadow flex-wrap el-tabs__content">
    <!--  -->
    <!-- 重要指标 -->
    <index-common v-if="page.isIndex"
                  v-loading="loading.indexLoading"
                  element-loading-background="#FFF"
                  element-loading-spinner="el-icon-loading"
                  element-loading-customClass="defineLoading"
                  element-loading-text="拼命的加载中"
                  class="block-preview noCompare_min"
                  :options="summaryList">
    </index-common>
    <!-- 趋势图 -->
    <chart-content :flod="flod"
                   v-if="page.isChart">
      <div class="flex-between gragh-index">
        <!-- 图的指标 -->
        <component :is="page.selectChart"
                   :class-key="page.chartKey"
                   :number="page.chartNum"
                   :indicator="page.indicator"
                   :address="page.chartAddress">
        </component>
      </div>
      <!-- 1个图 -->
      <component :is="page.oneChart"
                 v-loading="loading.chartLoading"
                 element-loading-background="#FFF"
                 element-loading-spinner="el-icon-loading"
                 element-loading-customClass="defineLoading"
                 element-loading-text="拼命的加载中"
                 :options="option5">
      </component>
    </chart-content>
    <!-- 自定义指标、表格 -->
    <div style="position: relative"
         :class="page.isChart?'width-full padding-bottom-md':'graph-table'"
         v-if="page.isTable">
      <zoom @zoom="changeflod"
            v-if="page.chartZoom"></zoom>
      <!-- 表的指标 -->
      <component :is="page.selectTable"
                 :class-key="page.tableKey"
                 :number="page.tableNum"
                 :address="page.tableAddress">
      </component>
      <div class="table_min"
           v-if="page.isTableKey"
           v-loading="loading.tableLoading"
           element-loading-background="#FFF"
           element-loading-spinner="el-icon-loading"
           element-loading-customClass="defineLoading"
           element-loading-text="拼命的加载中">
        <component :title="page.tableTitle"
                   :is="page.normalTable"
                   :tableInfo="tableInfo"
                   :devsort-style="tableInfo.devsort">
        </component>
      </div>
    </div>
  </div>

</template>

<script>
import * as queryUtil from "../../../common/query";
import * as util from "../../../common/util";
import * as Func from "../../../common/commonFun";
import { content } from "./component";
export default {
  props: {
    page: [Object]
  },
  components: {
    ...content
  },
  data() {
    return {
      loading: {
        indexLoading: false,
        chartLoading: true,
        tableLoading: false
      },
      queryData: {
        compareType: 0,
        identifyKey: "",
        headerType: 1,
        constantKey: "",
        parentID: -1,
        constantType: 0,
        dateFormat: 1,
        pageNum: 1,
        sortIndex: 1,
        ascending: 0,
        pageSize: 20
      },
      query: {},
      // 表格
      tableInfo: {},
      // 指标
      summaryList: [],
      // 按周
      tabPosition: "",
      disabled: [false, false],
      flod: false,
      option5: {}
    };
  },
  created() {
    this.queryData.constantKey = this.page.constantKey;
  },
  watch: {
    "$store.state.query_data": function(v) {
      this.queryData = Object.assign({}, this.queryData, v);
      this.getIndex();
      this.getTable();
      this.getChart();
    }
  },
  methods: {
    // 关键指标
    getIndex() {
      if (
        this.$route.name === this.page.name &&
        Object.keys(this.queryData).indexOf("indicatorIDs") >= 0
      ) {
        this.queryData.identifyKey = this.page.tableKey;
        this.queryData.constantType = this.page.TableconstantType;
        // 正常情况
        Func.getIndexTwo(this, this.queryData);
      }
    },
    // 查询表格和重要指标
    getTable() {
      // 正常的有关键指标，也有图表
      if (
        this.$route.name === this.page.name &&
        Object.keys(this.queryData).indexOf("indicatorIDs") >= 0 &&
        this.page.isTableKey
      ) {
        this.queryData.identifyKey = this.page.tableKey;
        this.queryData.constantType = this.page.TableconstantType;

        if (this.page.normalTable === "OneTable") {
          Func.getOneTableTwo(this, this.queryData);
        }
      }
    },
    // 查询chart
    getChart() {
      if (
        this.$route.name === this.page.name &&
        Object.keys(this.queryData).indexOf("indicatorIDs") >= 0
      ) {
        this.queryData.identifyKey = this.page.chartKey;
        this.queryData.constantType = this.page.ChartconstantType;
        // 特殊情况，新会员来源分析页面表头没有会员，但是要传isOld字段
        if (this.page.oneChart === "VueColumn") {
          if (this.page.chartSort) {
            // 排序的柱状图
            Func.getSortCloumnOne(this, this.queryData);
          } else {
            // 不排序的柱状图
            Func.getCloumnOne(this, this.queryData);
          }
        }
      }
    },
    changeflod(val) {
      this.flod = val;
    }
  }
};
</script>

<style lang="less">
</style>
